import { EntityAttributeDetailDto, SearchEntityModelDto } from '@/api/backoffice/clients';
import { ENUM_StatusTypes } from './configuration-enumerations.common';

export const entityModelLabel = (entityModel: SearchEntityModelDto) => {
    let status = '';

    if (entityModel.statusId !== ENUM_StatusTypes.Actief.id) {
        status = ` [${Object.values(ENUM_StatusTypes).find((x) => x.id === entityModel.statusId)?.name}]`;
    }

    return `[${entityModel.id}] ${entityModel.code} (${entityModel.label})${status}`;
};

export const entityAttributeLabel = (type: EntityAttributeDetailDto) => {
    return `${type.code} (${type.label})`;
};

export const entityModelSortFunction = (a: SearchEntityModelDto, b: SearchEntityModelDto) => {
    const sortable = (entityModel: SearchEntityModelDto) => `${entityModel.code} (${entityModel.label})`;
    return sortable(a) > sortable(b) ? 1 : -1;
};

export enum EntityModelActionButtonType {
    ChangeStatus = 'ChangeStatus',
    Duplicate = 'Duplicate',
    CascadeDelete = 'CascadeDelete',
    Export = 'Export'
}

export const sortDomainValues = (values: string[], dataType: string): string[] => {
    if (!values || values.length === 0) {
        return [];
    }
    let sortedValues = [];

    if (dataType === 'Getal') {
        sortedValues = values.sort((a, b) => {
            const numA = parseFloat(a);
            const numB = parseFloat(b);
            const isInvalidNumA = isNaN(numA);
            const isInvalidNumB = isNaN(numB);
            if (isInvalidNumA && isInvalidNumB) {
                return 0;
            } else if (isInvalidNumA) {
                return -1;
            } else if (isInvalidNumB) {
                return 1;
            } else {
                return numA - numB;
            }
        });
    } else if (dataType === 'Datum' || dataType === 'Datum + tijd') {
        sortedValues = values.sort((a, b) => {
            const dateA = new Date(a);
            const dateB = new Date(b);
            const isInvalidDateA = isNaN(dateA.getTime());
            const isInvalidDateB = isNaN(dateB.getTime());
            if (isInvalidDateA && isInvalidDateB) {
                return 0;
            } else if (isInvalidDateA) {
                return -1;
            } else if (isInvalidDateB) {
                return 1;
            } else {
                return dateA.getTime() - dateB.getTime(); // valid dates sorted in ascending order
            }
        });
    } else {
        sortedValues = values.sort();
    }

    return sortedValues;
};
